<main class="top info">
    <div id="background" class="keyvisual"></div>
    <h1></h1>
    <template v-if="app.error">
        <div class="guide">
            <p>{{app.error || 'Test'}}</p>
        </div>
    </template>
    <template v-else-if="!app.house">
        <div class="guide">
            <p>Loading</p>
        </div>
    </template>
    <template v-else-if="!app.getLang()">
        <div>
            <div class="content language">
                <h2><span class="icon">language</span>Language</h2>
                <div class="buttons language">
                    <button @click="app.setLang('ja')">日本語</button>
                    <button @click="app.setLang('en')">English</button>
                    <button @click="app.setLang('cn')">簡体中文</button>
                    <button @click="app.setLang('ko')">한글</button>
                </div>
            </div>
        </div>
    </template>
    <template v-else>
        <section class="greeting">
            <h2>{{_('greeting_title')}}</h2>
            <pre>{{ _(app.house.greeting) }}</pre>
            <p>{{_(app.house.name)}}</p>
        </section>
        <div class="buttons-wrapper">
            <button class="skeleton back" @click="app.setLang(null)">
                <span class="icon"> chevron_left </span>
            </button>
            <button class="next" @click="proceed()">{{_('next')}}</button>
            <div class="dummy"></div>
        </div>
    </template>
    <footer v-if="app.house">
        <p>Powered by {{ app.service_name }}</p>
    </footer>
</main>
